// ----------------------------------------------------------------------
// <copyright file="Izenda.LazyLoadingVirtualNode.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import { observer } from 'mobx-react';

export default class LazyLoadingVirtualNode extends Component {
  static propTypes = {
    store: PropTypes.object,
    source: PropTypes.object      
  };

  componentDidUpdate() {
    const { store, source } = this.props;
    store.updateVirtualNodes(source, this.virtualNodeDom);
  }

  componentDidMount() {
    const { store, source } = this.props;
    store.updateVirtualNodes(source, this.virtualNodeDom);
  }

  setDom = (dom) => {
    this.virtualNodeDom = dom;
  };

  render() {
    return (
      <div
        ref={this.setDom}
        className={this.props.className}
        style={{ height: '0px' }}>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./ui/share/components/controls/LazyLoading/Izenda.LazyLoadingVirtualNode.js